export const dataUrlToFile = async (
  dataUrl: string,
  name?: string,
  mimeType?: string,
): Promise<{ file: File; fileUrl: string }> => {
  const res = await fetch(dataUrl);
  if (!res.ok) {
    throw new Error('Failed to get blob from dataUrl');
  }

  const type = mimeType || res.headers.get('content-type') || '';
  const fileName = name || generateFileNameFromUrl(dataUrl, type);

  const blob = await res.blob();
  const file = new File([blob], fileName, { type });
  const fileUrl = fileToUrl(file);

  return { file, fileUrl };
};

const generateFileNameFromUrl = (url: string, mimeType: string) => {
  const filename = url.split('/').pop();
  const type = mimeType.split('/').pop();
  return `${filename}.${type}`;
};

export const fileToUrl = (file: File | Blob) => URL.createObjectURL(file);

export const saveFile = async (
  filename: string,
  fileUrl: any,
): Promise<void> => {
  const a = document.createElement('a');
  a.href = fileUrl;
  a.download = filename || 'File';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();

  URL.revokeObjectURL(fileUrl);
  document.body.removeChild(a);
};
